import { render } from "./UiLink.vue?vue&type=template&id=6cba2e15&ts=true"
import script from "./UiLink.vue?vue&type=script&lang=ts"
export * from "./UiLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__